import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { appointmentBookingPreferredTimeEvent } from '../actions.js';

const usePreferredTimeDataLayerEventDispatchers = ({ appointmentCondition , store , type , isVirtualAppointment , timeSlot  })=>{
    const createDataLayerEvent = React.useCallback((text_of_the_element, step_number)=>{
        if (store && type) {
            const { ageGroup , id: typeId  } = type;
            var _globalStoreId;
            return appointmentBookingPreferredTimeEvent({
                condition_of_appointment: appointmentCondition,
                step_number,
                appointment: {
                    type_of_appointment: isVirtualAppointment ? 'videocall' : 'onsite',
                    type_of_service: typeId
                },
                storeDetails: swcHelpers.objectSpread({
                    id: (_globalStoreId = store.globalStoreId) !== null && _globalStoreId !== void 0 ? _globalStoreId : '',
                    city: store.town
                }, store),
                text_of_the_element,
                time: {
                    startTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.from,
                    endTime: timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.until
                },
                ageGroup
            });
        }
    }, [
        store,
        type,
        timeSlot,
        appointmentCondition,
        isVirtualAppointment
    ]);
    return React.useMemo(()=>({
            onPreferredTimeClick: ()=>{
                const stepNumber = getStepNumber(false, appointmentCondition);
                const dataLayerEvent = createDataLayerEvent('preferred time', stepNumber);
                if (dataLayerEvent) {
                    DataLayer.pushEvent(dataLayerEvent);
                }
            },
            onPreferredTimeFilterClick: ({ option  })=>{
                try {
                    const elementText = getElementTextBasedOnOption(option);
                    const stepNumber = getStepNumber(true, appointmentCondition);
                    const dataLayerEvent = createDataLayerEvent(elementText, stepNumber);
                    if (dataLayerEvent) {
                        DataLayer.pushEvent(dataLayerEvent);
                    }
                } catch (error) {
                    console.error(error);
                // noop
                }
            }
        })
    , [
        createDataLayerEvent,
        appointmentCondition
    ]);
};
const isOptionContainsTime = (obj)=>typeof obj === 'object' && !!obj && 'from' in obj && 'until' in obj
;
const getElementTextBasedOnOption = (option)=>{
    if (isOptionContainsTime(option)) {
        if (option.name === 'noPreference') {
            throw new Error('no preference option should not have times defined');
        }
        return `${option.from} - ${option.until}`;
    }
    /*
    if from and until are undefined
    then option.name === noPreference and in this case we need to send 'no time preference'
    because the user clicked the first option that doesn't contain any specific time preference
  */ return 'no time preference';
};
const getStepNumber = (refersToButtonInTimeFilterModal, appointmentCondition)=>{
    let step_number;
    if (refersToButtonInTimeFilterModal) {
        step_number = appointmentCondition === 'new' ? '330' : '820';
    } else {
        step_number = appointmentCondition === 'new' ? '320' : '810';
    }
    return step_number;
};

export { getElementTextBasedOnOption, getStepNumber, usePreferredTimeDataLayerEventDispatchers };
//# sourceMappingURL=use-preferred-time-dl-event-dispatchers.js.map
